import { Button, Form, Input, Row } from 'antd';
import classes from '../../common/styles/FormStyles.module.scss';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { notificationType } from '../../common/constants/notificationType';
import globalNotification from '../../common/hooks/globalNotification';
import { constants } from '../../common/constants/constants';
import logo from '../../assets/check-vin-logo.png';
import { iconColor } from '../../theming';
import { useTranslation } from 'react-i18next';
import getInputRules, { inputType } from '../../utils/getInputRules';

export const RestorePassword = () => {
    const navigate = useNavigate();
    const params = useParams();
    const { t } = useTranslation(['resetPassword', 'apiResponses', 'form']);

    const onFormSubmit = async form => {
        try {
            await axios
                .post(`${constants.API_BASE_URL}/auth-consumers/restore-password`, {
                    id: params.id,
                    token: params.token,
                    newPassword: form.password,
                })
                .then(() => {
                    globalNotification.open({
                        type: notificationType.SUCCESS,
                        message: t('notification.success.message'),
                        description: t('notification.success.description'),
                        placement: 'top',
                    });
                    navigate('/auth/sign-in');
                });
        } catch (error) {
            const errorCode = error.response?.data?.code;

            globalNotification.open({
                type: notificationType.ERROR,
                message: t(`apiResponses:${errorCode}.message`),
                description: t(`apiResponses:${errorCode}.description`),
                placement: 'top',
            });
        }
    };

    return (
        <div className={classes['auth-wrapper']}>
            <div className={classes['auth-card']}>
                <img src={logo} alt="CheckVIN.ai" className={classes.logo} />
                <h3>{t('title')}</h3>
                <div className={classes.content}>
                    <p className={classes['check-instruciton']}>{t('sub')}</p>
                    <Form onFinish={onFormSubmit}>
                        <Form.Item
                            className={classes['form-item']}
                            label={<span className={classes['form-label']}>{t('password')}</span>}
                            name="password"
                            rules={getInputRules(t, inputType.PASSWORD, t('errors.password'))}
                            hasFeedback
                            style={{ marginBottom: '18px' }}
                            labelCol={{ span: 24 }}
                        >
                            <Input.Password
                                className={classes['input-login']}
                                prefix={
                                    <i
                                        className="fi-rr-lock"
                                        style={{ fontSize: '18px', color: iconColor.signin, marginRight: '12px' }}
                                    />
                                }
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item
                            className={classes['form-item']}
                            label={<span className={classes['form-label']}>{t('confirm')}</span>}
                            name="confirm"
                            dependencies={['password']}
                            hasFeedback
                            labelCol={{ span: 24 }}
                            style={{ marginBottom: '24px' }}
                            rules={[
                                {
                                    required: true,
                                    message: t('form.errors.confirm'),
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(t('form.errors.confirm-match')));
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                className={classes['input-login']}
                                prefix={
                                    <i
                                        className="fi-rr-lock"
                                        style={{ fontSize: '18px', color: iconColor.signin, marginRight: '12px' }}
                                    />
                                }
                                size="large"
                            />
                        </Form.Item>
                        <Row justify="center" align="center">
                            <Button className={classes.signin} htmlType="submit" type="primary" size="large">
                                {t('button')}
                            </Button>
                        </Row>
                    </Form>
                </div>
            </div>
        </div>
    );
};
